export enum LogEntryParameters {
  internalWorkCenterId = 'internalWorkCenterId',
  internalPileTurnerId = 'internalPileTurnerId',
  apiUrl = 'apiUrl'
}
